module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "ch5"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_24",
      "title": "24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("3")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Chap-Title-ct"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE ACADEMY")])])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_c('span', {
    staticClass: "cic"
  }, [_vm._v("M")]), _vm._v("oving between the bus and USAFA base exchange, we learned how to march to the cadre’s guttural cadence call. There was something so primal—a camaraderie so visceral—inspired by their rhythmic guidance. Like a tribal call to arms. The driving rhythm started pulling our disparate crowd together. In front of me was a broad-shouldered, skinny Wiffle ball of a boy wearing a Notre Dame shirt. I had the same shirt, though I knew not to wear it on the first day of starting a rival university. To my left, there was a boy wearing a gold chain, Michael Jordan basketball jersey, shorts that sagged below his waistline, and an angled baseball cap that barely hid his red-cheeked and snarled attempt at bravado. Allegedly, USAFA was 11 percent female, but the girl to my immediate right was the only other female I had seen thus far in the sea of new cadets surrounding me. She wore a tank top, Daisy Dukes, cowboy boots, and a cowboy hat that shaded her peaches-’n’-cream face from the summer sun. Within the first five minutes of “instruction,” the cadre moved right past Notre Dame Boy, and spanked both Basic Daisy’s and Basic Bull’s hats off their respective heads with such force that they UFO’d their way to the middle of the terrazzo. We all watched openmouthed "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_25",
      "title": "25"
    }
  }, [_vm._v("and wide-eyed, while the beat thumped on, and we strove to answer the call toward cooperative competence. We were in our infantry infancy, but we were definitely becoming part of something much bigger than ourselves.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Being part of a large group of synchronous soldiers felt powerful. My skin buzzed as the collective current of kinetic energy grew in size and speed.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Soon, we had remastered the art of walking and looked as if we were playing a game of human centipede. An upperclassman with a blinding array of silver on his uniform swooped down on me to correct my form. Following his booming earthquake of a voice came a tsunami of saliva that drenched my neck and shoulder. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Eww.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“GET YOUR CHIN INNN, BASIC!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He whipped out a credit card from his wallet and shoved the hard plastic under my chin like the blade of a guillotine.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“MY CREDIT CARD SHOULD STAY IN BETWEEN YOUR DOUBLE AND TRIPLE CHINS, BASIC!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Double")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("… TRIPLE chins?!")]), _vm._v(" My mother had reminded me how to minimize the appearance of such a horrific feature my entire life. I was pretty sure that he had just called my neck fat, but I was too confused to be offended. So I did the only acceptable thing: I smashed my "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("multiple")]), _vm._v(" chins together like an accordion, then jammed everything against the back of my spine. I answered Sir Spits-a-Lot as best I could through my flattened airway.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Yes, sir!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I sounded like a flight attendant making a nasally announcement over a plane’s PA system.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“WE TUCK IN OUR CHINS, BASIC, BECAUSE IF YOU NEED TO EJECT FROM YOUR AIRCRAFT AND YOU DO "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("NOT")]), _vm._v(" TUCK IN YOUR CHIN, YOUR HEAD WILL SURE AS SHIT "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("SNAP")]), _vm._v(" OFF "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_26",
      "title": "26"
    }
  }, [_vm._v("OF YOUR BODY! YOU WILL "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("DIE")]), _vm._v(" IF YOU DO NOT TUCK YOUR CHIN IN, BASIC! DO YOU UN-DER-STAND?!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Yes, sir!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I scanned my mental inventory of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Top Gun")]), _vm._v(" and every other military movie for an example of soldiers tucking in their chins. I could not think of a single one. I had never seen it, most likely because no A-list actor or his A-list agent would want an accordion of chins under his firmly squared, bankable jaw. I sympathized while I fought the urge to massage my "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("fat")]), _vm._v(" neck.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The cadre granted us permission to be “at rest” (free to move without marching or falling in at attention—provided that we adhered to verbal etiquette) throughout our next inprocessing errand. I breathed a sigh of relief. I let my eyes out of their cages, unglued my chin from the back of my spine, and rubbed my d"), _c('span', {
    staticClass: "span-accent-characters-acc"
  }, [_vm._v("é")]), _vm._v("colletage. I still felt the three-inch credit card imprint on my skin.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("A finger poked my shoulder blade.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Let us move it, Tate.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The required robotic, contraction-free speech pattern made the upperclassman behind me sound like a Transformer toy. I felt his hand again, so I responded.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Yes, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("He nudged me toward the back of a short line of somber girls next to a long line of rambunctious boys. The spacey tingle of premonition crept around the base of my skull. I turned around to find Cadet Optimus Prime winking at me above a sly grin. My heart sank.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Haircut.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I had known this moment would come. Ninety-five percent of me had been looking forward to the transformation, but I had not expected to feel so crushed by the objecting five percent. I had spent the last several years trying to grow out my short hairdo, trying to live "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_27",
      "title": "27"
    }
  }, [_vm._v("down my ridiculous tomboy moniker. It had taken me a long time to do both. The obstinate five percent of me was afraid that the little girl who had disappointed her daddy by being mistaken for a boy would reemerge at the end of this line. I shook my head from side to side, surprised by the regression of my psyche.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Suck it up, Popo.")]), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("…")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The closer I inched toward the front of the line, the more fuzzy tennis-ball heads I saw emerge from beyond the partition of the makeshift barbershop. Those who had chosen to get their hair cut short before arriving at the academy seemed to have suffered only a slight trim.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Maybe I should have done that, too")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("… but then again, nope.")]), _vm._v(" I needed to experience this moment for my own complete transformation into Soldier Girl. The life that I had chosen required a substantial commitment. I was willing to commit. And I truly believed that there could be no subtle transition into the life I was about to lead.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I stepped up to the door like a soldier reporting for duty. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Er")]), _vm._v(" … perhaps more like a teenage girl reluctantly choosing duty over vanity. Over identity.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("It was a start. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Bring it on.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Once I was inside, a woman with a poorly dyed bouffant hairdo impatiently waved me into her empty barber’s chair. Her colleague—sporting a beehive hairdo—was already in the middle of cutting another girl’s hair. Neither woman paused or looked up at me as I filled the open seat.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Hand me my cape, wouldja…?” Ms. Bouffant asked.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Ms. Beehive grabbed a black plastic cape with her scissor hand and whipped it over at Ms. Bouffant, who snapped it a little too tightly around my neck. Before I could speak up, she had gathered my long hair into a ponytail at the base of my skull and lopped it off. She "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_28",
      "title": "28"
    }
  }, [_vm._v("just … "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("lopped it off")]), _vm._v(" without thinking, flinching, warning, waiting, or even pausing in her conversation with Ms. Beehive. Thirteen inches of my life. Lopped off.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The air flew from my lungs like wind from a punctured balloon. I felt light-headed. Literally. Ms. Bouffant didn’t skip a beat.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Oh my "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("God")]), _vm._v(", you would "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("not")]), _vm._v(" believe who I saw at Citadel Mall yesterday!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Snip.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Uh-huh, that’s right! Can you believe he had the nerve to show his face?”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Snip, snip.")]), _vm._v(" Ms. Beehive never answered Ms. Bouffant. She was either mute, or was actually concentrating on the hair that she was cutting. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("God")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("… Did I get into the wrong chair")]), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("…")]), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("?")]), _vm._v(" My heart started to race. My identity was cascading to the floor in huge chunks. There was no mirror in sight, so all I had to measure the devastation was the time it took … and it took a "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("long")]), _vm._v(" time. Ms. Bouffant didn’t seem like the type to take a long time to do anything, but she was sure as shit taking a long time to cut my hair.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“There you go, sweetie pie,” said Ms. Beehive, breaking her silence. She took her girl’s cape as if she was expecting a tip. The cadet simply stood and walked, shell-shocked, from Ms. Beehive’s chair to the tiny mirror in the corner of the room. She began to sob—softly at first—plummeting quickly into a full-out ugly cry. She fell to her knees, her face crumpled. She threw her hands upward in apocalyptic fury. My eyes widened as I watched silently.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Dear. Snip. God. Snip. Panic. Snip. Panic. Panic. Panic. What am I doing here?")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Ms. Bouffant’s shears finally stopped their staccato beat. Before she could even take off the plastic sheath, my hands were running fiendishly through my hair. I didn’t have any. She pulled at the cape. "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_29",
      "title": "29"
    }
  }, [_vm._v("I hung on to what was left of my hair for fear that her shears might find their way back to my fuzzy skull. She yanked and we ended up tangled in a tug-of-war of plastic/arms/head/plastic until she literally whipped me out of the chair. I spun and tumbled all the way over to join Basic Ugly Cry in the corner. I looked into the mirror.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("It was a drastic change. A solitary tear escaped its duct and inched its way down my right cheek, but I promptly smeared its campaign. There would be no pity party. This was the beginning of a new challenge … a new me. This half a moment was all the time I would give myself to mourn the loss of something that didn’t define the whole of me. It wasn’t my entire identity, and I knew it. Half a moment. It was all I’d give.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I dragged my short hair, my huge bag, and my transformed self toward an older civilian gentleman at the last station.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Looks like you may need a hand with that thing, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("missy")]), _vm._v("!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“No, sir, but thank you, sir!” I smiled, still feeling a bit clunky with the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("sirs")]), _vm._v(". The five-year-old inside of me sighed with relief that he had addressed me—with my plushy head—as female … no matter how condescendingly. I picked up my bag and threw it over my shoulder to prove I wasn’t a weakling … in case this, too, was a test. It spun me one and a half times around so that Mr. Missy’s next comment was directed at the back of my head.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“Welp, here ya go!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Mr. Missy pulled three sets of camouflage battle dress uniforms (BDUs) up from under the countertop and slid them over to me. I stared at the bundle of clothing like a bundle of gold bricks. A chill shot up my spine. I was being issued new skin.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("In this skin, I can get as dirty and as sweaty as I want. In this skin, I can work and play as hard as I want. In this skin, I will not be judged for wanting to run outside and play in the dirt with the boys. In this")]), _vm._v(" "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_30",
      "title": "30"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("skin, I will not have to worry about what I look like. In this skin, I will not be called a tomboy. In this skin, I will only be encouraged to give 200 percent, to leave it all out on the floor.")])])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I opened the top of my Santa sack and laid the BDUs neatly on top of my new shirts, pants, sweat suits, boots, shoes, hats, gloves, underwear, socks, deodorant, shoe polish, and other unidentifiable miscellany, the purpose of which I had absolutely no idea. I smiled. I felt as if I were Tiny Tim taking a huge gulp of steaming hot chocolate, following its heated trail down to my stomach, then deep into my soul. My physical transformation into a soldier was nearly complete.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("God bless us")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("… every one.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("By the time we arrived at the dormitory barracks, the majority of the incoming class had been divvied out among Lego-like buildings along the terrazzo. USAFA’s cadet wing, mirroring an active air force wing, included 4,417 cadets broken down into forty squadrons, each one numbered and labeled with a corresponding mascot. Ten squadrons formed a "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("group.")]), _vm._v(" For basic cadet training purposes, however, each squadron was broken down further into a series of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("flights")]), _vm._v("—the smallest organizational unit—and named with letters of the alphabet. Those of us in Demons E-Flight eventually found ourselves standing in front of our new home, Vandenberg Hall.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“DEMONNNS, FORWAAARD HAULT!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Our flight leader’s command stopped us from marching straight into the building. I recognized the dorm from my recruiting trip.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“LISTEN UP, BASICS! THIS IS VANDENBERG HALL.”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Nearly every building and landmark on academy grounds was named after a fallen hero or hallowed soldier. Much like Vandenberg Hall, which was the first of two cadet barracks on campus. It housed squadrons one through twenty, whereas Sijan Hall—on the opposite side of the cadet inner sanctum—housed squadrons twenty-one "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_31",
      "title": "31"
    }
  }, [_vm._v("through forty. Each squadron had a name and mascot attached to its number. For instance, the wing’s first squadron, Mighty Mach One, was known for being "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("stract")]), _vm._v(" (soldier who keeps the most fastidious uniform and strictest military decorum) and keeping their number one ranking in all things military matched with their position in the wing. Unsure of our school-year housing, we had stopped at the stairwell leading up to the Tough Twenty Trolls of squadron twenty for the summer.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("I snuck a peek at the vertical line of windows above my head as we walked into the building. They’d all been painted to look like the colorful squadron patches adorning the upperclassmen’s jackets. Accessories. Exactly what my parents had overtly hinted to be the “appropriate” amount of collegiate creativity: a morsel to feed my inner artist, but, dare I try to make it my whole life’s meal, they feared I would become another starving artist on the street. The swirled brushstrokes on the glass curled up the corners of my mouth. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Did cadets paint these? Could I paint these")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("… and more?")]), _vm._v(" I’d need at least one artistic outlet to fully thrive here—after all, I had promised my high school teammates.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“BASIC CADET TATE! YOU AND SMALLTOWN ARE IN THERE!”")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Once we landed on our floor, our flight leader pointed to an open door down the hall.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57722966","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter5.vue
// module id = 84
// module chunks = 0